class coments {
  constructor(rolId, id, coment, codeApply) {
    this.id = id;
    this.rolId = rolId;
    this.coment = coment;
    this.codeApply = codeApply
  }
  static fromJson({ rolId, comentId, comentario, codAplica }) {
    return new coments(rolId, comentId, comentario, codAplica);

  }
}
export default coments


